import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

export interface FeatureCard2BlockProps extends ComponentPropsWithRef<"div"> {
  description?: ReactNode;
  icon?: ReactNode;
  image?: ReactNode;
  titleContent?: ReactNode;
}

export const FeatureCard2Block = forwardRef<
  HTMLDivElement,
  FeatureCard2BlockProps
>(({ icon, titleContent, image, description, className, ...rest }, ref) => (
  <div
    ref={ref}
    className={classNames(
      "wb-bg-primary wb-flex wb-flex-col wb-gap-[1.875rem] wb-rounded-[1.25rem] wb-p-[1.88rem]",
      className,
    )}
    {...rest}
  >
    {icon}
    <div className="wb-flex wb-flex-col wb-gap-4">
      <div className="wb-flex wb-flex-col wb-gap-3">
        {titleContent}
        {image}
      </div>
      {description}
    </div>
  </div>
));

FeatureCard2Block.displayName = "FeatureCard2Block";
